// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dac853b7","455":"618dc0ca","977":"0431fb8a"}[chunkId] + ".chunk.js";
};